// removed by extract-text-webpack-plugin
module.exports = {"p20":"p20__cQQhj","a20":"a20__1ZRxd","p40":"p40__3VzM0","a40":"a40__1UbGA","p60":"p60__3fWd2","a60":"a60__2usKO","p80":"p80__2h0Uz","a80":"a80__1csQd","p100":"p100__2Ovid","a100":"a100__1rcsg","shape2":"shape2__1V3nV","s1":"s1__1aOlh","mb16":"mb16__2YYFL"};


//////////////////
// WEBPACK FOOTER
// ./components/ConnectingAnimation/ConnectingAnimation.css
// module id = Kvx2
// module chunks = 16